import NextLink from "next/link";
import type { ComponentPropsWithoutRef } from "react";

import { IcArrowRight } from "@jetblue/kit-icons/ic-arrow-right";
import { IcExternal } from "@jetblue/kit-icons/ic-external";

export type LinkProperties = {
  isExternal?: boolean | undefined;
  showArrowRight?: boolean | undefined;
} & ComponentPropsWithoutRef<typeof NextLink>;
export const Link = ({
  children,
  className = "",
  isExternal = false,
  showArrowRight = false,
  ...properties
}: LinkProperties) => (
  <NextLink className={`flex items-center gap-1 ${className}`} {...properties}>
    {children}

    {isExternal && <IcExternal />}

    {!isExternal && showArrowRight && <IcArrowRight />}
  </NextLink>
);
